const ENV = require("../_env");
const g = (window[ENV.projectName] = window[ENV.projectName] || {});

import Contents from "../_modules/Contents";
import MainVisual from "../_modules/MainVisual";

const _ASSETS_DIR = "./assets";

const _KV_IMG_SETTINGS = {
  s: {
    img1: `${_ASSETS_DIR}/images/img3.jpg`,
    img2: `${_ASSETS_DIR}/images/img2.jpg`,
    resolution: [1024, 1024],
    orgResolution: [1280, 720],
    maxAspectRatio: 1280 / 720,
    minAspectRatio: 1280 / 720
  },

  l: {
    img1: `${_ASSETS_DIR}/images/img3.jpg`,
    img2: `${_ASSETS_DIR}/images/img2.jpg`,
    resolution: [2048, 1024],
    orgResolution: [1280, 720],
    maxAspectRatio: 1280 / 720,
    minAspectRatio: 1280 / 720
  }
};

export default class Index extends Contents {
  constructor() {
    super();
    this._init();
    let isOne = false;
    window.test = () => {
      isOne = !isOne;
      this.mainVisual.setMode(isOne);
    };
  }

  async _initContents() {
    await this._initMainVisual();
  }

  async _wait(duration) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, duration);
    });
  }

  async _initMainVisual() {
    const self = this;
    return new Promise(async resolve => {
      this.mainVisual = new MainVisual({
        el: self.body.querySelector(".js-mainVisual"),
        store: this.store,
        async mounted() {
          await this.init(_KV_IMG_SETTINGS, self.store.state.layoutMode);
          resolve();
        }
      });
    });
  }

  _resizeContents() {
    this.mainVisual && this.mainVisual.onResize(this.store.state.layoutMode);
  }
}
